import React, { Fragment } from 'react'
import AdminTools from './AdminTools'
import Navbar from '../Navbar/Navbar'
import SubHeaderContainer from '../../containers/SubHeader/SubHeader'
import TrackingHOC from '../../hocs/TrackingHOC'
import HeaderExternal from './HeaderExternal'

const HeaderDefault = ({
  allowCustomerOverride,
  location,
  query,
  createUserEvent,
  landingCategories,
  customer,
  devices,
  currentDevice,
  modulesAvailable,
  toggleSearchModal,
  toggleDeviceModal,
  language,
  clearDevice,
  showHeader,
  getOption,
  topLinks
}) => {
  return (
    <Fragment>
      {allowCustomerOverride && <AdminTools location={location} />}
      <Navbar
        location={location}
        query={query}
        createUserEvent={createUserEvent}
        landingCategories={landingCategories}
        currentDevice={currentDevice}
        toggleDeviceModal={toggleDeviceModal}
        showHeader={showHeader}
        getOption={getOption}
        topLinks={topLinks}
      />

      <SubHeaderContainer
        toggleSearchModal={toggleSearchModal}
        devices={devices}
        getOption={getOption}
        language={language}
        currentDevice={currentDevice}
        clearDevice={clearDevice}
        toggleDeviceModal={toggleDeviceModal}
        query={query}
        modulesAvailable={modulesAvailable}
        externalNavEnabled={false}
        customer={customer}
      />
    </Fragment>
  )
}

const Header = props => {
  const { version } = props
  return version === 'v1' ? <HeaderDefault {...props} /> : <HeaderExternal {...props} version={version} />
}

export default TrackingHOC(Header)



// WEBPACK FOOTER //
// ./src/components/Header/Header.js